import {createStore} from 'vuex'

import LocalizationLanguage from "@/store/localization/language";
import LocalizationTax from "@/store/localization/tax";
import LocalizationCountry from "@/store/localization/country";
import LocalizationCountryState from "@/store/localization/country/state";
import LocalizationCountryCity from "@/store/localization/country/city";
import AuthModule from "@/store/module/AuthModule";
import BodyModule from "@/store/module/BodyModule";
import BreadcrumbsModule from "@/store/module/BreadcrumbsModule";
import ConfigModule from "@/store/module/ConfigModule";
import File from "@/store/file";
import SiteLocalizationLanguage from "@/store/site/localization/language";
import SiteLocalizationCurrency from "@/store/site/localization/currency";
import SiteLocalizationTax from "@/store/site/localization/tax";
import SiteLocalizationCountry from "@/store/site/localization/country";
import SiteLocalizationCountryState from "@/store/site/localization/country-state";
import SiteLocalizationCountryCity from "@/store/site/localization/country-city";
import SiteAdminUser from "@/store/site/admin/user/";
import SiteAdminGroup from "@/store/site/admin/group/";
import Permission from "@/store/permission/";
import SiteSettingsSystemVariable from "@/store/site/settings/system-variable";
import SiteSettingsRegisterElement from "@/store/site/settings/register-element";
// Site yönetimi — içerik modülleri (ticatix'ten türetildi)
import SiteSliderGroup from "@/store/site/slider/group/";
import SiteSliderItem from "@/store/site/slider/item/";
import SiteSliderButton from "@/store/site/slider/button/";
import SiteBlogPost from "@/store/site/blog/post/";
import SiteBlogCategory from "@/store/site/blog/category/";
import SiteSuccessStory from "@/store/site/success-story/";
import SitePopupItem from "@/store/site/popup/item/";
import SitePopupButton from "@/store/site/popup/button/";
import SitePageItem from "@/store/site/page/item/";
import SiteFormItem from "@/store/site/form/item/";
import SiteFormElement from "@/store/site/form/element/";
import SiteFormAnswer from "@/store/site/form/answer/";
import SiteLinkManager from "@/store/site/link/manager/";
import SiteMenuManager from "@/store/site/menu/manager/";
import SiteMenuItem from "@/store/site/menu/item/";
import SiteFaqGroup from "@/store/site/faq/group/";
import SiteFaqCategory from "@/store/site/faq/category/";
import SiteFaqItem from "@/store/site/faq/item/";
import ManagerPackage from "@/store/manager/package/";
import ManagerCustomer from "@/store/manager/customer/";
import ManagerSite from "@/store/manager/site/";
import ManagerSubscription from "@/store/manager/subscription/";
import ManagerInvoice from "@/store/manager/invoice/";
import ManagerOrder from "@/store/manager/order/";
import ManagerSupport from "@/store/manager/support/";
import ManagerLead from "@/store/manager/lead/";
import ManagerSegment from "@/store/manager/segment/";
import ManagerCampaign from "@/store/manager/campaign/";
import ManagerAutomation from "@/store/manager/automation/";
import ManagerActivityLog from "@/store/manager/activityLog/";
import ManagerDeployment from "@/store/manager/deployment/";
import AppStore from "@/store/app/";

/*
 * Manager store — ticatix'ten sadeleştirildi. E-ticaret ve storefront modülleri
 * kaldırıldı. Manager modülleri (CRM, müşteri&site, paket, abonelik, otomasyon)
 * faz faz eklenecek. Korunan: Metronic çekirdeği, izin, yerelleştirme, dosya,
 * ekip/rol (site.admin), temel sistem ayarları.
 */
export const store = createStore({
    modules: {
        AuthModule,
        BodyModule,
        BreadcrumbsModule,
        ConfigModule,
        permission: Permission,
        app: AppStore,
        manager: {
            namespaced: true,
            modules: {
                package: ManagerPackage,
                customer: ManagerCustomer,
                site: ManagerSite,
                subscription: ManagerSubscription,
                invoice: ManagerInvoice,
                order: ManagerOrder,
                support: ManagerSupport,
                lead: ManagerLead,
                segment: ManagerSegment,
                campaign: ManagerCampaign,
                automation: ManagerAutomation,
                activityLog: ManagerActivityLog,
                deployment: ManagerDeployment,
            }
        },
        localization: {
            namespaced: true,
            modules: {
                language: LocalizationLanguage,
                tax: LocalizationTax,
                country: Object.assign(LocalizationCountry, {
                    modules: {state: LocalizationCountryState, city: LocalizationCountryCity}
                })
            }
        },
        file: File,
        site: {
            namespaced: true,
            modules: {
                slider: {
                    namespaced: true,
                    modules: {group: SiteSliderGroup, item: SiteSliderItem, button: SiteSliderButton}
                },
                blog: {
                    namespaced: true,
                    modules: {post: SiteBlogPost, category: SiteBlogCategory}
                },
                successStory: SiteSuccessStory,
                popup: {
                    namespaced: true,
                    modules: {item: SitePopupItem, button: SitePopupButton}
                },
                page: {
                    namespaced: true,
                    modules: {item: SitePageItem}
                },
                form: {
                    namespaced: true,
                    modules: {item: SiteFormItem, element: SiteFormElement, answer: SiteFormAnswer}
                },
                link: {
                    namespaced: true,
                    modules: {manager: SiteLinkManager}
                },
                menu: {
                    namespaced: true,
                    modules: {manager: SiteMenuManager, item: SiteMenuItem}
                },
                faq: {
                    namespaced: true,
                    modules: {group: SiteFaqGroup, category: SiteFaqCategory, item: SiteFaqItem}
                },
                localization: {
                    namespaced: true,
                    modules: {
                        language: SiteLocalizationLanguage,
                        currency: SiteLocalizationCurrency,
                        tax: SiteLocalizationTax,
                        country: SiteLocalizationCountry,
                        countryState: SiteLocalizationCountryState,
                        countryCity: SiteLocalizationCountryCity,
                    }
                },
                admin: {
                    namespaced: true,
                    modules: {user: SiteAdminUser, group: SiteAdminGroup}
                },
                settings: {
                    namespaced: true,
                    modules: {
                        systemVariable: SiteSettingsSystemVariable,
                        registerElement: SiteSettingsRegisterElement,
                    }
                }
            }
        }
    }
});

export default store;
